export class AwsGrantedServices {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "ec2",
            "baseName": "ec2",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "rds",
            "baseName": "rds",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "s3",
            "baseName": "s3",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dynamodb",
            "baseName": "dynamodb",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "eks",
            "baseName": "eks",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "fsx",
            "baseName": "fsx",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "efs",
            "baseName": "efs",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "documentdb",
            "baseName": "documentdb",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "neptune",
            "baseName": "neptune",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "keyspaces",
            "baseName": "keyspaces",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "opensearch",
            "baseName": "opensearch",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsGrantedServices.attributeTypeMap;
    }
    constructor() {
    }
}
